import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
// @mui
import { Button, Container, Stack, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

// components
import Iconify from '../components/iconify';
import ProductDataList from '../sections/@dashboard/products/ProductDataList';
import { Url } from '../url/url';

// import ProductDataList from 'src/sections/@dashboard/products/ProductDataList';



// ----------------------------------------------------------------------
const SORT_OPTIONS = [
  { value: 'latest', label: 'Latest' },
  { value: 'popular', label: 'Popular' },
  { value: 'oldest', label: 'Oldest' },
];
// ----------------------------------------------------------------------
const initialValue = {
  data: [],
  totalCount: 0,
  totalPages: 1,
  currentPage: 1
}
const ProductsPage = () => {
  const productAllData = useSelector(store => store.product.data)
  const categoryAllData = useSelector(store => store.category.data)
  const [searchData, setSearchValueData] = useState()
  const [dataValue, setDataValue] = useState([])

  const [product, setProduct] = useState(initialValue)
  const [limit, setLimit] = useState(5)
  const [totalPage, setTotalPage] = useState(1)
  const [currentPage, setCurrentPage] = useState(1)


  const searchfunc = async (value) => {
    if (value.length > 0) {
      let findproduct = await axios.get(`${Url}/product/search/${value}`)
      findproduct = findproduct.data
      setSearchValueData(findproduct)
    }
    else {
      setSearchValueData()
    }
  }

  const dataSet = (categoryvalue) => {
    if (categoryvalue) {
      if (categoryvalue) {
        setDataValue(productAllData.filter(val => val.category === categoryvalue))
      }
      else {
        setDataValue(productAllData)
      }
    }
    else {
      setDataValue(productAllData)
    }
  }

  const fetchDataFunc = async () => {
    try {
      const response = await axios.get(`${Url}/product?limit=${limit}&page=${currentPage}`).then(data => data.data)
      setTotalPage(response.totalPages)
      setProduct(response)
    } catch (error) {
      console.log("error", error);
    }
  }

  const productDrop = async (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        await axios.delete(`${Url}/product/delete/${id}`).then(() => {
          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Item Delete Successfully',
            showConfirmButton: false,
            timer: 1000
          })
          // dispatch(productdata())
        }).catch((error) => {
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: 'something went wrong',
            showConfirmButton: false,
            timer: 1500
          })
        })

      }
    })
  }

  const updateProductTagFunc = async(id, tag)=>{ 
    try {
      await axios.put(`${Url}/product/update-product-tag/${id}`, {tag})
      fetchDataFunc()
    } catch (error) {
      console.log(error);
      
    }
  }

  const onPageChange = (pageNumber) => {
    setCurrentPage(pageNumber)
  }
  const changeLimitFunc = (limitNumber) => { 
    setLimit(limitNumber)
    setCurrentPage(1)
  }
 
  useEffect(() => {
    fetchDataFunc()
  }, [currentPage, limit])

  useEffect(() => {
    dataSet()
  }, [productAllData])


  return (
    <>
      <Helmet>
        <title> Dashboard: Products | Doozie-do </title>
      </Helmet>

      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={3}>
          <Typography variant="h4" gutterBottom>
            Product
          </Typography>
          <Button variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}>
            <Link className='text-white ' to="/dashboard/add-product">Add New</Link>
          </Button>
        </Stack>
      </Container>

      <Container className=' '>
        <div className='d-flex align-items-center justify-content-between felx-wrap bg-lightgray rounded-top p-3'>
          <div>
            <form>
              <input type='text' onChange={e => searchfunc(e.target.value)} placeholder='Search' className='form-control' />
            </form>
          </div>
          <div className='d-flex gap-2 align-items-top'>
            {/* <div >
              <p className='mb-1 me-2'>Category </p> 
                <select onChange={e => dataSet(e.target.value)} className='border-0 rounded p-1'>
                  <option value="">All</option>
                  {categoryAllData.map((cv, i) => {
                    return (
                      <option value={cv.category} className='text-capitalize' key={i}>{cv.category} </option>
                    )
                  })}
                </select> 
            </div> */}
            <div>
              <p className='mb-1'>Limit</p>
              <select value={limit} onChange={e => changeLimitFunc(e.target.value)} className='border-0 rounded p-1'>
                <option value="5">5</option>
                <option value="10">10</option>
                <option value="20">20</option>
                <option value="30">30</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>
          </div>
        </div>
      </Container>
      <Container>
        <section className='table-responsive'>
          <table className='table table-striped table-bordered text-center table-hover align-top'>
            <thead className='table-primary'>
              <tr className='align-top'>
                <th>Product Image</th>
                <th>Product Name</th>
                <th>Character</th>
                <th>SubCharacter</th>
                <th>MRP</th>
                <th>Sale Price</th>
                <th>Tag</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {product.data?.map((cv, i) => {
                return (
                  <tr className='text-center' key={i}>
                    <td className=''>
                      <img src={`${cv.thumbnailImage}`} alt="" className='img-fluid mx-auto' style={{ width: "70px" }} />
                    </td>
                    <td className=''>{cv.productName}</td>
                    {/* <td  className=''>{cv.category}</td> */}
                    {/* <td  className=''>{cv.subcategory}</td> */}
                    <td className=''>{cv.character}</td>
                    <td className=''>{cv.subcharacter}</td>
                    <td className=''>&#8377; {cv.mrp}</td>
                    <td className=''>&#8377; {cv.salePrice}</td>
                    {/* <td>{cv.tags}</td> */}
                    <td>
                      <select name="tags" id="" className='form-select' value={cv.tags} onChange={(e)=>updateProductTagFunc(cv._id, e.target.value)}>
                        <option value="">Null</option>
                        <option value="top picks">Top Picks  </option>
                        <option value="new arrival">New Arrival  </option>
                      </select>
                    </td>
                    <td  >
                      <div className='d-flex align-items-center'>
                        <Link to={`/dashboard/updateproduct/${cv._id}`} className='btn border-0'>
                          <i className="fa-solid fa-pen-to-square text-warning fa-lg " /> <br />
                        </Link>
                        <button className='btn border-0' onClick={e => productDrop(cv._id)}>
                          <i className="fa-solid fa-trash text-danger fa-lg" />
                        </button>
                        <Link className='btn border-0' to={`/dashboard/product/${cv._id}`}>
                          <i className="fa-solid fa-eye text-primary fa-lg" />
                        </Link>
                      </div>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </section>

        <nav >
          <ul className="pagination justify-content-center">
            {/* Previous Button */}
            <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1}>
                Previous
              </button>
            </li>

            {/* Page Numbers */}
            {Array.from({ length: totalPage }, (_, index) => index + 1).map((page) => (
              <li key={page} className={`page-item ${currentPage === page ? "active" : ""}`}>
                <button className="page-link" onClick={() => onPageChange(page)}>
                  {page}
                </button>
              </li>
            ))}

            {/* Next Button */}
            <li className={`page-item ${currentPage === totalPage ? "disabled" : ""}`}>
              <button className="page-link" onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPage}>
                Next
              </button>
            </li>
          </ul>
        </nav>

      </Container>
      <Container>
        {/* {searchData ? <ProductDataList data={searchData} /> : <ProductDataList data={dataValue} />} */}
      </Container>



    </>
  );
}

export default ProductsPage
